import React, { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { baseAxios } from "../apis";

const AdsContext = createContext();

const routeToSlotMap = {
  "/dashboard": "home_bottom",
  "/bot-list": "bot_dashboard",
  "/account": "market_sidebar",
};

const fetchAdBySlot = async (slot) => {
  // Return null or throw an error if no slot, to prevent a bad API call
  if (!slot) return null;
  const { data } = await baseAxios.get(`api/ads/${slot}/`);
  return data;
};

export const AdsProvider = ({ children }) => {
  const location = useLocation();
  const matchedSlot = routeToSlotMap[location.pathname];

  // Pass a single object to useQuery
  const {
    data: ads,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["ads", matchedSlot],
    queryFn: () => fetchAdBySlot(matchedSlot),
    enabled: !!matchedSlot,
    staleTime: 1000 * 60 * 5,
  });

  const value = { ads, loading: isLoading, error, currentSlot: matchedSlot };

  return <AdsContext.Provider value={value}>{children}</AdsContext.Provider>;
};

export const useAds = () => useContext(AdsContext);
